import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import isGHMC, { formatDateTimeWithoutSec, formattedDate, getCurrentDate, getCurrentDateTime, getFirstDateOfMonth, getStartOfCurrentDate } from "../../../../Common/helper/helpar";
import MSWManagementSecondaryCollectionStore from "./store/MSWManagementSecondaryCollectionStore";
import { MSWManagementVehiclesExport } from "./MSWManagementVehiclesExport";

export const MSWManagementVehiclesFilter = () => {
  const { fetchMSWManagementSecondaryCollectionReport } = MSWManagementSecondaryCollectionStore();
  const isProd = isGHMC();
  const currentDate = getCurrentDate();
  const currentDateTime = getCurrentDate();
  const todayDate = getCurrentDateTime();
  // Calculate last 30 days for validation
  const getLast30DaysDate = (day) => {
    const toDate = new Date(day);
    const thirtyDaysAgo = new Date(toDate.setDate(toDate.getDate() - 30));
    return thirtyDaysAgo.toISOString().split("T")[0];
  };

  // Default values
  const defaultValues = {
    FromDate: getFirstDateOfMonth(),
    ToDate: currentDate,
  };

  // Initialize filters from localStorage or defaults
  const getInitialFilters = () => {
    const stored = localStorage.getItem("mswSecondaryCollectionFilters");
    return stored ? JSON.parse(stored) : defaultValues;
  };

  const [initialFilterValues, setInitialFilterValues] = useState(getInitialFilters);

  // State to track the currently applied filters (for heading/export)
  const [filterDates, setFilterDates] = useState(getInitialFilters);

  useEffect(() => {
    fetchMSWManagementSecondaryCollectionReport(initialFilterValues);

    // If localStorage not present, store defaults
    const stored = localStorage.getItem("mswSecondaryCollectionFilters");
    if (!stored) {
      localStorage.setItem("mswSecondaryCollectionFilters", JSON.stringify(initialFilterValues));
    }
  }, []); // Run only on mount

  const handleSubmit = (values, { setSubmitting }) => {
    // Update localStorage and state
    localStorage.setItem("mswSecondaryCollectionFilters", JSON.stringify(values));
    setInitialFilterValues(values);
    setFilterDates(values); // <-- update current applied filters
    fetchMSWManagementSecondaryCollectionReport(values);
    setSubmitting(false);
  };

  const handleReset = (resetForm) => {
    resetForm({ values: defaultValues });
    localStorage.setItem("mswSecondaryCollectionFilters", JSON.stringify(defaultValues));
    setInitialFilterValues(defaultValues);
    setFilterDates(defaultValues); // <-- update current applied filters
    fetchMSWManagementSecondaryCollectionReport(defaultValues);
  };

  // Format date/time for heading or export
  const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <div>
      {/* Heading showing only selected filters */}
      <div className="top-header mb-3">
        <span style={{ fontWeight: "bold" }}>
          MSW Management Vehicles On The Road - Secondary Collection as on (
          {formattedDate(filterDates.FromDate)} - {formattedDate(filterDates.ToDate)}) at {formatDateTimeWithoutSec(todayDate)}
        </span>
      </div>

      <Formik initialValues={initialFilterValues} enableReinitialize onSubmit={handleSubmit}>
        {({ values, resetForm, isSubmitting }) => (
          <Form>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div className="d-flex align-items-end gap-2 mb-2">
                {/* From Date */}
                <div style={{ width: "200px" }}>
                  <div className="form-group-filter">
                    <label className="form-label w-100 text-left">From Date</label>
                    <Field
                      type="date"
                      id="FromDate"
                      name="FromDate"
                      className="form-control bg-white"
                      min={values.ToDate && getLast30DaysDate(values.ToDate)}
                      max={values.ToDate || currentDate}
                      required
                    />
                  </div>
                </div>

                {/* To Date */}
                <div style={{ width: "200px" }}>
                  <div className="form-group-filter">
                    <label className="form-label w-100 text-left">To Date</label>
                    <Field
                      type="date"
                      id="ToDate"
                      name="ToDate"
                      className="form-control bg-white"
                      min={values.FromDate}
                      max={currentDate}
                      required
                    />
                  </div>
                </div>

                {/* Buttons */}
                <button
                  type="submit"
                  className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                  disabled={isSubmitting}
                >
                  Search
                </button>
                <button
                  type="button"
                  className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                  onClick={() => handleReset(resetForm)}
                >
                  Reset
                </button>
              </div>

              {/* Export */}
              <div className="mt-4 d-flex">
                <MSWManagementVehiclesExport
                  fromDate={filterDates.FromDate} // <-- use currently selected filters
                  toDate={filterDates.ToDate}     // <-- use currently selected filters
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
